/**
 * Convert YouTube / Vimeo URLs into proper embed URLs.
 * Returns null if URL is not a recognized video host.
 */
export function toEmbedUrl(url) {
  if (!url || typeof url !== "string") return null;
  const u = url.trim();

  // YouTube watch (https://www.youtube.com/watch?v=ID&...)
  const ytWatch = u.match(/(?:youtube\.com\/watch\?[^\s]*v=)([\w-]{6,15})/);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}?rel=0`;

  // YouTube short (https://youtu.be/ID)
  const ytShort = u.match(/youtu\.be\/([\w-]{6,15})/);
  if (ytShort) return `https://www.youtube.com/embed/${ytShort[1]}?rel=0`;

  // YouTube already embed
  const ytEmbed = u.match(/youtube\.com\/embed\/([\w-]{6,15})/);
  if (ytEmbed) return `https://www.youtube.com/embed/${ytEmbed[1]}?rel=0`;

  // Vimeo (https://vimeo.com/ID)
  const vimeo = u.match(/vimeo\.com\/(\d{5,})/);
  if (vimeo) return `https://player.vimeo.com/video/${vimeo[1]}`;

  // Already player.vimeo.com
  const vimeoEmbed = u.match(/player\.vimeo\.com\/video\/(\d{5,})/);
  if (vimeoEmbed) return `https://player.vimeo.com/video/${vimeoEmbed[1]}`;

  return null;
}

export function hasVideo(url) {
  return toEmbedUrl(url) !== null;
}
